var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99844 6.67344C5.88177 6.67344 5.76944 6.65244 5.66144 6.61044C5.55277 6.56911 5.45677 6.50677 5.37344 6.42344L0.873437 1.92344C0.723437 1.77344 0.648438 1.59844 0.648438 1.39844C0.648438 1.19844 0.723437 1.02344 0.873437 0.873438C1.02344 0.723438 1.19844 0.648438 1.39844 0.648438C1.59844 0.648438 1.77344 0.723438 1.92344 0.873438L5.99844 4.94844L10.0734 0.873438C10.2234 0.723438 10.3984 0.648438 10.5984 0.648438C10.7984 0.648438 10.9734 0.723438 11.1234 0.873438C11.2734 1.02344 11.3484 1.19844 11.3484 1.39844C11.3484 1.59844 11.2734 1.77344 11.1234 1.92344L6.62344 6.42344C6.5401 6.50677 6.44444 6.56911 6.33644 6.61044C6.22777 6.65244 6.1151 6.67344 5.99844 6.67344Z",
    fill: "#79869A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorArrow);
export default __webpack_public_path__ + "static/media/doctor-arrow.b392736618d6ab45795469385258c2cb.svg";
export { ForwardRef as ReactComponent };